import { useEffect, useRef } from "react";
import YouTubePlayer from "youtube-player";
import { YouTubePlayer as YouTubePlayerType } from "youtube-player/dist/types";

export const Video = ({
  videoId,
  autoplay = false,
  className = "",
  restartThreshold = 0.3, // seconds before end to restart
}: {
  videoId: string;
  autoplay?: boolean;
  className?: string;
  restartThreshold?: number;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const playerRef = useRef<YouTubePlayerType>(null);
  const intervalRef = useRef<number>(null);

  useEffect(() => {
    if (containerRef.current) {
      // Create player instance
      playerRef.current = YouTubePlayer(containerRef.current, {
        videoId,
        playerVars: {
          controls: autoplay ? 0 : 1,
          autoplay: autoplay ? 1 : 0,
          loop: 0,
          modestbranding: 1,
          rel: 0,
          iv_load_policy: 3,
          playsinline: 1,
          disablekb: 0,
          fs: 1,
        },
      });

      // Poll for near-end condition
      intervalRef.current = window.setInterval(async () => {
        if (playerRef.current)
          try {
            const [time, duration] = await Promise.all([
              playerRef.current.getCurrentTime(),
              playerRef.current.getDuration(),
            ]);
            // Restart video near end to try avoid ads or starting a new video
            if (duration > 0 && time >= duration - restartThreshold) {
              await playerRef.current.seekTo(0, true);
              await playerRef.current.playVideo();
            }
          } catch {
            // ignore errors when player not ready
          }
      }, 500);
    }

    return () => {
      if (intervalRef.current) window.clearInterval(intervalRef.current);
    };
  }, [videoId, restartThreshold, autoplay]);

  return (
    <div className={`aspect-video overflow-hidden ${className}`}>
      {/* youtube-player injects an iframe here */}
      <div ref={containerRef} className="h-full w-full" />
    </div>
  );
};
